/**
 * navToggle.js
 * Handles toggling mobile navigation
 *
 */
export default class navigation {

    constructor() {

        this.settings = {
            navToggle: document.getElementById('navigation-toggle'),
            body: document.getElementsByTagName('body')[0],
            activeClass: 'js-nav-open'
        }

    }

    init() {

        if (null !== this.settings.navToggle) {
            this.bindUIActions();
        }

    }

    bindUIActions() {

        const { navToggle, body, activeClass } = this.settings;

        // Close mobile menu if screen is resized up
        window.addEventListener('resize', () => {
            if (window.innerWidth > 899) {
                body.classList.remove(activeClass);
                navToggle.setAttribute('aria-expanded', 'false');
            }
        });

        // Close menu if ESC is pressed
        window.addEventListener('keydown', (e) => {
            if ('Escape' === e.code && body.classList.contains(activeClass)) {
                body.classList.remove(activeClass);
                navToggle.setAttribute('aria-expanded', 'false');
            }
        });

        // Toggle nav on button click
        navToggle.addEventListener('click', () => {
            const isOpen = body.classList.contains(activeClass);
            body.classList.toggle(activeClass);
            navToggle.setAttribute('aria-expanded', !isOpen);
        });

    }

}
